import { render, staticRenderFns } from "./UeditorWrap.vue?vue&type=template&id=6fd5f6df&scoped=true&"
import script from "./UeditorWrap.vue?vue&type=script&lang=js&"
export * from "./UeditorWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5f6df",
  null
  
)

export default component.exports